import { api } from '@/api/client';
export async function fetchMyAddresses() {
    const { data } = await api.get('/v1/me/addresses');
    return data;
}
export async function createMyAddress(address, isDefault = false) {
    const { data } = await api.post('/v1/me/addresses', { address, isDefault });
    return data;
}
export async function updateMyAddress(id, address, isDefault) {
    const { data } = await api.put(`/v1/me/addresses/${id}`, { address, isDefault });
    return data;
}
export async function deleteMyAddress(id) {
    await api.delete(`/v1/me/addresses/${id}`);
}
